import axios from 'axios'

const APP_KEY = process.env.VUE_APP_APP_KEY

axios.defaults.baseURL = process.env.VUE_APP_API_URL
axios.defaults.headers['Access-Controll-Allow-Origin'] = '*'
axios.defaults.headers['app_key'] = `${APP_KEY}`

import { setStorage, clearStorage } from '../_helpers';

export default {
  async login ({ commit }, account) {
    const { data } = await axios.post('/auth/admin/signin', { username: account.username, password: account.password })
    commit('setAdmin', data)
    setStorage('_admin', data)
  },
  logout({ commit }) {
    commit('logout')
    clearStorage('_admin')
  }
}